// extracted by mini-css-extract-plugin
export default {"root":"ResultsBadges_root__ilMTs","top":"ResultsBadges_top__cv5dg","title":"ResultsBadges_title__49-5u","sessions":"ResultsBadges_sessions__jpU7K"};